<template>
  <div class="page">
    <Header title="易加网活动页" :show-back="false" />
    <div class="subject">易加签到惊喜礼</div>
    <div class="content">
      <van-cell-group>
        <van-field v-model="authData.loginAccount" center clearable placeholder="请输入易加网账号" />
        <van-field v-model="authData.password" type="password" center clearable placeholder="请输入登录密码" />
      </van-cell-group>

      <div class="button-line">
        <van-button type="primary" size="large" @click="submitData">点 击 有 礼</van-button>
      </div>
      <div class="tips">
        <div><van-icon name="arrow" /> 此活动仅限2019年5月21日参与</div>
        <div><van-icon name="arrow" /> 此活动仅限易加网修理厂渠道客户参与</div>
        <div><van-icon name="arrow" /> 已领取过礼品的客户不能重复参加</div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/header'
import activityApi from '@/api/activity'
import { commonUtils } from '@/utils/common'
export default {
  name: 'ActivitySign521',
  components: {
    Header
  },
  data () {
    return {
      authData: {
        loginAccount: '',
        password: ''
      }
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    submitData () {
      if (!this.authData.loginAccount) {
        this.$dialog.alert({ message: '请填写您的易加网登录账号' })
        return false
      }
      if (!this.authData.password) {
        this.$dialog.alert({ message: '请填写您的易加网登录密码' })
        return false
      }
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        mask: true,
        message: '提交验证...'
      })
      activityApi.submitActivitySign521(this.authData).then(response => {
        this.$toast.clear()
        if (response.data.resultCode === '0') {
          this.$dialog.alert({
            title: '恭喜您',
            message: '获得1000积分，点击确定返回易加网首页',
            confirmButtonText: '确定'
          }).then(() => {
            window.location.href = commonUtils.getExtraSite()
          })
        // } else {
        //   if (response.data.resultMsg) {
        //     this.$toast(response.data.resultMsg)
        //   }
        }
      }).catch(() => {
        this.$toast.clear()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.page {
  height: calc(100% - 46px);
  background: url('../../assets/images/sign521-bg.png');
  background-size: contain;
  background-position-y: 46px;
}
.subject {
  text-align: center;
  font-size: 24px;
  line-height: 30px;
  font-weight: 700;
  color: #117281;
  padding: 24px 0;
}

.content {
  width: 80%;
  margin: 12px auto;
}
.button-line {
  margin: 20px 0 0 0;
}
.tips {
  padding: 32px 0;
  font-size: 12px;
  line-height: 24px;
  font-style: italic;
}
</style>
